// Local storage
export enum LocalStorageKey {
	ACCESS_TOKEN = 'access_token',
	ROLE = 'role',
	SELECTED_LANGUAGE = 'selected_language',
	TOKEN_EXPIRES_AT = 'token_expires_at'
}

// Language
export enum Language {
	DE = 'de',
	EN = 'en',
	ES = 'es',
	FR = 'fr',
	IT = 'it',
}

export enum DateLanguage {
	FR = 'fr-FR',
	US = 'en-US',
	ES = 'es-ES',
	DE = 'de-DE',
	IT = 'it-IT'
}

// Status
export enum Status {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	DELETED = 'deleted'
}

// Inputs
export enum SelectOptionType {
	DIVIDER = 'divider',
	OPTION = 'option',
}
